import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "./AllSolutionsRequestNewProject.css";
import { FiPhone } from "react-icons/fi";
import mainImage from "../../../../assets/images/allsolutions/main2.webp"

const AllSolutionsRequestNewProject = () => {
  const { t } = useTranslation();

  return (
    <section className="allSolutionsRequestNewProject">
      <div className="allSolutionsRequestNewProject-top">
        <div className="allSolutionsRequestNewProject-content">
          <span className="allSolutionsRequestNewProject-tag">
            {t("sections.allSolutions.requestProject.tag")}
          </span>

          <h2 className="allSolutionsRequestNewProject-title">
            {t("sections.allSolutions.requestProject.title")}{" "}
            <span>{t("sections.allSolutions.requestProject.titleAccent")}</span>
          </h2>

          <p className="allSolutionsRequestNewProject-text">
            {t("sections.allSolutions.requestProject.text")}
          </p>

          <div className="allSolutionsRequestNewProject-actions">
            <Link to="/contactus#contact-form" className="buttongyp allSolutionsRequestNewProject-quoteBtn">
              {t("sections.allSolutions.requestProject.getQuote")}
            </Link>

            <Link to="/contactus#contact-form" className="allSolutionsRequestNewProject-callBtn">
              <span>{t("sections.allSolutions.requestProject.requestCallback")}</span>
              <FiPhone className="allSolutionsRequestNewProject-phoneIcon" />
            </Link>
          </div>
        </div>
      </div>

      <div className="allSolutionsRequestNewProject-imageWrap">
        <img
          src={mainImage}
          alt={t("sections.allSolutions.requestProject.imageAlt")}
          className="allSolutionsRequestNewProject-image"
        />

      </div>
    </section>
  );
};

export default AllSolutionsRequestNewProject;
